import { LOGIN_TOKEN } from '@/global/constants'

export const MOCK_LOGIN_SESSION_KEY = 'user/mock-login-session'

export interface MockLoginSession {
  originalToken: string | null
  mockToken: string
  startedAt: number
}

const getStorage = (storage?: Storage) => storage ?? window.localStorage

export function getMockLoginSession(storage?: Storage): MockLoginSession | null {
  const targetStorage = getStorage(storage)
  const rawSession = targetStorage.getItem(MOCK_LOGIN_SESSION_KEY)
  if (!rawSession) return null

  try {
    const session = JSON.parse(rawSession) as Partial<MockLoginSession>
    if (
      typeof session.mockToken !== 'string' ||
      !session.mockToken ||
      typeof session.startedAt !== 'number' ||
      (session.originalToken !== null &&
        typeof session.originalToken !== 'string')
    ) {
      return null
    }
    return session as MockLoginSession
  } catch {
    return null
  }
}

export function activateMockLoginSession(
  mockToken: string,
  storage?: Storage
): MockLoginSession {
  const normalizedToken = mockToken.trim()
  if (!normalizedToken) throw new Error('拟登录凭证缺失')

  const targetStorage = getStorage(storage)
  const activeSession = getMockLoginSession(targetStorage)
  const session: MockLoginSession = {
    originalToken: activeSession
      ? activeSession.originalToken
      : targetStorage.getItem(LOGIN_TOKEN),
    mockToken: normalizedToken,
    startedAt: Date.now()
  }

  targetStorage.setItem(MOCK_LOGIN_SESSION_KEY, JSON.stringify(session))
  targetStorage.setItem(LOGIN_TOKEN, normalizedToken)
  return session
}

export function restoreOriginalLoginToken(storage?: Storage): string | null {
  const targetStorage = getStorage(storage)
  const session = getMockLoginSession(targetStorage)
  if (!session) return targetStorage.getItem(LOGIN_TOKEN)

  if (session.originalToken) {
    targetStorage.setItem(LOGIN_TOKEN, session.originalToken)
  } else {
    targetStorage.removeItem(LOGIN_TOKEN)
  }
  targetStorage.removeItem(MOCK_LOGIN_SESSION_KEY)
  return session.originalToken
}

export function clearMockLoginSession(storage?: Storage) {
  getStorage(storage).removeItem(MOCK_LOGIN_SESSION_KEY)
}
